import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Headers, Http } from "@angular/http";
import { ApiEvsService } from "app/common/services/ApiEvs.service";
@Injectable()
export class RequestBoxSendService {
  headers: Headers;
  url = environment.qrcode_url;

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem("Access-Token");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  // box(body): Observable<any> {
  //   return this.http.post(`${environment.qrcode_url}/box`, body, {headers: this.headers});
  // }

  requestBoxSendList(query?: any): Observable<any> {
    // @ts-ignore
    return this.http
      .get(`${this.url}/transfer/request/return/send_back`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  // @ts-ignore
  requestBoxSendDetail(query?: any, id): Observable<any> {
    // @ts-ignore
    return this.http
      .get(`${this.url}/transfer/request/return/send_back/${id}`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  requestBoxSendActive(id, body): Observable<any> {
    // @ts-ignore
    return this.http
      .put(`${this.url}/transfer/request/return/send_back/${id}`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  requestBoxSendStatistic(): Observable<any> {
    return this.http
      .get(`${this.url}/transfer/request/return/send_back/statistic`, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  stampSerial(id): Observable<any> {
    // @ts-ignore
    return this.http
      .get(`${this.url}/stamp/${id}`, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/requestBoxSend/services/requestBoxSend.service.ts